import React from 'react';
import { TimePicker } from 'antd';
import { Dayjs } from 'dayjs';
import { TextComponent } from 'baseComponents/TextComponent';
import 'baseComponents/TimePickerComponent/timePickerComponent.scss';
interface Props {
  onChange: (value: Dayjs | null, dateString: string) => void;
  value: Dayjs | null;
  disabledTime?: any;
  noLabel?: boolean;
}

export const TimePickerComponent: React.FC<Props> = (props) => {
  return (
    <div>
      {!props.noLabel && (
        <TextComponent text='Time' size='middle' weight='extra-light' />
      )}
      <TimePicker
        value={props.value}
        format='HH:mm'
        showSecond={false}
        showNow={false}
        suffixIcon={<></>}
        className='time-picker-input'
        popupClassName='time-card'
        allowClear={false}
        onChange={props.onChange}
        disabledTime={props.disabledTime}
      />
    </div>
  );
};
